import api from './api';

/**
 * Gmail connection admin surface (WQ-260817-01 Phase 3 UI, CL-260824-01).
 *
 * Both endpoints are @Roles('admin') server-side, and NEITHER ever returns a token or the client
 * secret: status() reports booleans plus the connected address, and beginConnect() returns a
 * single-use consent URL that grants nothing without a Google sign-in. That is why the URL is safe
 * to copy out of the page and hand to whoever actually holds the mailbox password - see the note in
 * gmail.controller.ts, which designed the link to be shareable for exactly that reason.
 *
 * There is no disconnect endpoint and this service deliberately does not invent one. Revoking is
 * done at myaccount.google.com/permissions by the mailbox owner, which is the only place that
 * actually severs Google's side of the grant.
 */
const gmailService = {
  /** Booleans, the connected mailbox, and granted scopes. Cheap and safe to re-poll. */
  getStatus: () => api.get('/admin/gmail/status'),
  getIntakeStatus: () => api.get('/admin/mail-intake/status'),

  /**
   * Mint a single-use consent link, good for 10 minutes.
   *
   * Calling this connects NOTHING by itself - it only writes a nonce. The connection is made when
   * a human opens the returned URL and completes Google's consent screen.
   */
  beginConnect: () => api.get('/admin/gmail/connect'),
};

export default gmailService;
